function isPassportExpirationDateValid(
  issueDate: Date | null | undefined,
  expirationDate: Date | null | undefined
): boolean {
  if (issueDate == null || expirationDate == null) {
    return false;
  }

  const issueDateCopy = new Date(issueDate);
  const expirationDateCopy = new Date(expirationDate);
  const maxDate = new Date(issueDateCopy.setUTCFullYear(issueDateCopy.getFullYear() + 20));

  if (expirationDateCopy.getTime() > maxDate.getTime() || expirationDateCopy.getTime() < new Date().getTime()) {
    return false;
  }

  return true;
}

export default isPassportExpirationDateValid;
